export enum UniformItemTopTypes {
  LongSleeve = "LONG_SLEEVE",
  Sleeveless = "SLEEVELESS",
  ShortSleeve = "SHORT_SLEEVE",
}
